import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface StatsCardProps {
  label: string;
  value: string;
  trend?: string;
  trendUp?: boolean;
  icon: React.ReactNode;
}
export function StatsCard({
  label,
  value,
  trend,
  trendUp,
  icon
}: StatsCardProps) {
  return <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-173">
      <div className="flex items-start justify-between mb-4" data-id="element-174">
        <div className="p-2 bg-orange-50 rounded-lg text-orange-500" data-id="element-175">
          {icon}
        </div>
        {trend && <div className={`flex items-center gap-1 text-xs font-medium ${trendUp ? 'text-green-600' : 'text-red-600'}`} data-id="element-176">
            {trendUp ? <ArrowUpRight className="w-3 h-3" data-id="element-177" /> : <ArrowDownRight className="w-3 h-3" data-id="element-178" />}
            {trend}
          </div>}
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-179">{value}</h3>
      <p className="text-sm text-gray-500" data-id="element-180">{label}</p>
    </div>;
}